import styled, { css } from 'styled-components';

const backgroundRed =
  'linear-gradient(220deg, rgba(244, 22, 22, 0.00) 3.21%, rgba(244, 22, 22, 0.40) 96.79%)';

const backgroundGrey =
  'linear-gradient(225deg,rgba(255, 255, 255, 0) 3.51%,rgba(255, 255, 255, 0.2) 96.49%)';

export const Gruop = styled.div`
  width: 100%;
  position: relative;

  > span {
    position: absolute;
    top: -24px;
    display: flex;
    text-transform: uppercase;
    margin-bottom: 4px;
  }
`;

export const Container = styled.div`
  width: 100%;
  position: relative;
  border-radius: 32px;
  z-index: 0;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 32px;
    padding: 2px;
    background: ${backgroundGrey};
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    z-index: -1;

    ${({ $type }) =>
      $type === 2 &&
      css`
        background: ${backgroundGrey};
      `}

    ${({ $type }) =>
      $type === 3 &&
      css`
        background: ${backgroundRed};
      `}
  }
`;

export const Background = styled.div`
  width: 100%;
  height: 150px;
  position: relative;
  display: flex;

  align-items: center;
  justify-content: center;
  gap: 28px;
  border-radius: 32px;
  padding: 20px 28px;
  overflow: hidden;

  background-image: url(${({ $glass }) => $glass});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  img {
    width: 100%;
    max-width: 100px;

    ${({ $type }) =>
      $type === 2 &&
      css`
        max-width: 90px;
      `}

    ${({ $type }) =>
      $type === 3 &&
      css`
        max-width: 100px;
      `}
  }

  .bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;

    > div {
      padding-bottom: 8px;
      border-bottom: 1px solid ${({ theme }) => theme.colors.grey.white};
    }

    span {
      text-transform: uppercase;
    }
  }
`;

export const Name = styled.div`
  width: fit-content;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 4px;

  h3 {
    font-family: 'Bebas Neue', sans-serif;
    font-weight: 300;
    font-size: 24px;
  }

  h2 {
    font-size: 48px;
    font-family: 'Anton', sans-serif;
    text-transform: uppercase;
    margin-bottom: -10px;
  }
`;

export const Body = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 20px;
  padding: 16px;
  border-radius: 0 0 32px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
`;

export const Ul = styled.ul`
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  list-style: none;
  padding: 0 20px;
  gap: 20px;

  li {
    width: fit-content;
    text-align: center;
    position: relative;
    font-size: 16px;
    font-weight: 300;

    &::before {
      content: '';
      position: absolute;
      /* top: 4px; */
      transform: translateY(100%) translateX(-180%);

      width: 6px;
      height: 6px;
      border-radius: 100%;
      background-color: ${({ theme }) => theme.colors.grey.white};
    }

    b {
      font-weight: 700;
    }
  }
`;
export const GroupPrice = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;

  .line {
    height: 50px;
    width: 1px;
    background-color: ${({ theme }) => theme.colors.grey.white};
  }
`;

export const Signature = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h2 {
    font-size: 52px;
    font-family: 'Anton', sans-serif;
    margin-bottom: -16px;
  }

  span {
    font-family: 'Anton', sans-serif;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 20px;
  }
`;

export const GroupButton = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  margin-top: 4px;

  .info {
    width: 100%;
    border: 0;
    background-color: transparent;
    color: ${({ theme }) => theme.colors.grey.white};

    span {
      font-size: 12px;
      font-weight: 400;
    }

    &:hover {
      transition: 0.7s;
      text-decoration: underline;
    }
  }

  .buy {
    width: 100%;
    position: relative;
    padding: 16px 0px;
    border-radius: 32px;
    border: 0;
    background: rgba(255, 255, 255, 0.4);
    z-index: 0;

    ${({ $type }) =>
      $type === 2 &&
      css`
        background: rgba(255, 255, 255, 0.4);
      `}

    ${({ $type }) =>
      $type === 3 &&
      css`
        background: 0;
        background-image: url(${({ $glass }) => $glass});
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
      `}

    h2 {
      /* font-family: 'Bebas Neue', sans-serif; */
      text-transform: uppercase;
      font-size: 22px;
      font-weight: 300;
      color: ${({ theme }) => theme.colors.grey.white};
    }

    &:hover {
      transition: 0.7s;
      opacity: 0.5;
    }

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 32px;
      padding: 2px;
      background: ${backgroundGrey};
      -webkit-mask: linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      z-index: -1;

      ${({ $type }) =>
        $type === 2 &&
        css`
          background: ${backgroundGrey};
        `}

      ${({ $type }) =>
        $type === 3 &&
        css`
          background: ${backgroundRed};
        `}
    }
  }
`;
